import { types } from 'mobx-state-tree';

import PolicyCancellationReasonValues from '../definitions/PolicyCancellationReasonValues';


const PolicyCancellation = types
    .model('PolicyCancellation', {
        id: types.identifier,
        reason: types.enumeration(
            Object.values(PolicyCancellationReasonValues),
        ),
        date: types.string,
        hasNextInsurance: types.boolean,
        nextInsuranceDate: types.maybeNull(types.string),
    });

export default PolicyCancellation;
